import { RecommendApp } from "@channelwill/components"
import { Banner, Layout, Link } from "@shopify/polaris"
import { observer } from "mobx-react"
import { useEffect } from "react"
import { Trans } from "react-i18next"
import { useHistory } from "react-router-dom"

import APIApp from "@/api/app"
import { useQueryDateSelect } from "@/common/useQueryDateSelect"
import { FooterLink } from "@/components"
import BadFeedBackModal from "@/components/BadFeedBackModal/BadFeedBackModal"
import V6MarketingBanner from "@/components/Banner/V6MarketingBanner"
import { CrossSellAppBanner } from "@/pages/Plan/component"
import stores from "@/stores"

import FeedBackHelpCard from "../Feedback/components/FeedbackHelpCard"
import {
  AppEmbedStatusCard,
  BookDemoBanner,
  DashboardDisplayList,
  PlanBadge,
  RecommendForYouCard,
  ReviewCard,
  UserGuide,
} from "./components"
import { PraiseGuideModal } from "./components/PraiseGuide"
import { RecommendedCard } from "./components/RecommendedCard/RecommendedCard"
import DashboardInit from "./DashboardInit"
const Dashboard = () => {
  const history = useHistory()
  const { UserInfoStore, ReturnRequestsDataStore, CommonStore } = stores

  // 初始化数据
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    DashboardInit.init({
      ...CommonStore.selectDateTime.dashboard,
      hasCompare: ReturnRequestsDataStore.hasCompare,
    })
  }, [])

  useEffect(() => {
    window.cio?.trigger({
      event: "view_home_page",
    })
    window.cwreport?.report("view_home_page")
  }, [])

  const { node } = useQueryDateSelect({
    onSubmit: (data) => {
      DashboardInit.batchGetChart(data.params)
      CommonStore.setSelectDateTime("dashboard", data.params)
    },
    date: CommonStore.selectDateTime.dashboard,
  })
  return (
    <div className="relative overflow-hidden mt-6">
      <div id="dashboard" className="container !max-w-[990px]">
        {/* 反馈弹窗*/}
        <BadFeedBackModal
          show={ReturnRequestsDataStore.show_bad_feed_back_modal}
          onClose={() => {
            ReturnRequestsDataStore.setShowBadFeedBackModal(false)
          }}
        />
        {/* 好评引导弹窗*/}
        <PraiseGuideModal
          open={
            ReturnRequestsDataStore.show_praise_guide_modal &&
            !UserInfoStore.data.is_close_praise_guide
          }
          title={t("DearXTeam", {
            replace: {
              x: UserInfoStore.data.store_name,
            },
          })}
          onClose={() => {
            ReturnRequestsDataStore.setShowPraiseGuideModal(false)
          }}
        />

        <Layout>
          <Layout.Section>
            <div className="flex justify-between flex-wrap items-center gap-2 mb-2">
              <h1 className="md:text-[20px] font-semibold">
                <Trans i18nKey="ParcelpanelReturnsByCWILL">
                  <Link
                    removeUnderline
                    onClick={() => {
                      history.push("/integration?tabsSelected=1")
                    }}
                  >
                    CWILL
                  </Link>
                </Trans>
              </h1>
              <div className="flex-shrink-0 flex items-center gap-4">
                {/* plan徽标 */}
                <PlanBadge />
                <div className="p-button-secondary-wrap">{node}</div>
              </div>
            </div>
          </Layout.Section>
          {UserInfoStore.showBanner.index_upgrade === 1 && (
            <Layout.Section>
              <V6MarketingBanner type={"upgradeindashboard"} />
            </Layout.Section>
          )}
          {/* TODO：加入真实的字段 */}
          {UserInfoStore.showBanner.carrier_payment_moved_banner === 1 && (
            <Layout.Section>
              <Banner
                title={t("ParcelwillCarrierPaymentIsNowUnder")}
                action={{
                  content: t("ViewNow"),
                  onAction() {
                    pnav("/settings/logistics-integration")
                  },
                }}
                onDismiss={async () => {
                  UserInfoStore.setShowBanner("carrier_payment_moved_banner", 2)
                  const res = await APIApp.closeBanner(24)
                  if (res.code !== 1000) {
                    UserInfoStore.setShowBanner(
                      "carrier_payment_moved_banner",
                      1,
                    )
                  }
                }}
              >
                {t("AddFundsAndManageParcelwillCarrier")}
              </Banner>
            </Layout.Section>
          )}

          {/* 首页book demo banner */}
          {UserInfoStore.showBanner?.index_book_demo === 1 && (
            <Layout.Section>
              {/* <BookADemo202506Banner /> */}
              <BookDemoBanner />
            </Layout.Section>
          )}
          {/* 首页cross sell app 交叉销售引导弹窗 */}
          {/* 所有订阅ParcelWILL Returns App Professional套餐（包含月费和年费套餐）及以上的商家，
                  排除Test charge, 排除Shopify plan状态为取消和冻结的店铺 */}
          {UserInfoStore.showBanner?.cross_sell === 1 &&
          UserInfoStore.data.is_show_cross_sell_banner ? (
            <Layout.Section>
              <CrossSellAppBanner />
            </Layout.Section>
          ) : null}

          <Layout.Section>
            <div className="flex flex-col gap-4">
              {/* 首页引导列表 */}
              {UserInfoStore.showBanner?.show_guide === 1 && <UserGuide />}
              {/* 为你推荐 */}
              <RecommendForYouCard />
              {/* 数据统计列表 */}
              <DashboardDisplayList
                hasCompare
                loading={ReturnRequestsDataStore.loading.dashboardLoading}
              />
              {/* 管理退货列表 */}
              <ReviewCard />
              <div className="space-y-4">
                <RecommendApp />
                {/* 推荐应用列表 */}
                {UserInfoStore.showBanner?.is_show_other_app === 1 && (
                  <RecommendedCard />
                )}
                <div className="!mb-4">
                  <AppEmbedStatusCard />
                </div>
                {/* 反馈帮助 */}
                <FeedBackHelpCard />
              </div>
            </div>
          </Layout.Section>
        </Layout>
        <FooterLink />
      </div>
    </div>
  )
}

export default observer(Dashboard)
